

import { Component, Vue } from 'vue-property-decorator';
import AvailableFeatureFlags from './AvailableFlagsSelector.vue';
import CurrentUserFlags from './CurrentUserFlags.vue';

@Component({
    components: {
        AvailableFeatureFlags,
        CurrentUserFlags
    }
})
export default class FeatureFlags extends Vue {
}
